import { useMemo } from 'react'
import { useSetAtom } from 'jotai'

import { authCityAtom } from '../atoms/auth-city.atom'

export const useAuthCitySetter = () => {
    const citySetter = useSetAtom(useMemo(() => authCityAtom, []))

    return {
        citySetter,
    }
}
